import { apiClient } from '@app/lib'
import type { SugarMeResponse } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import ms from 'ms'
import { useSession } from 'next-auth/react'

export const useMe = () => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated',
    queryKey: ['me'],
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<SugarMeResponse>(`/api/me`, { signal })

      return data.data
    },
    staleTime: ms('1h')
  })
}
